<div class="min-vh-100 d-flex justify-content-center align-items-center bg-light">
  <div class="card shadow-lg p-4" style="max-width: 400px; width: 100%; border-radius: 1rem;">
    <div class="text-center mb-4">
      <h3 class="fw-bold text-primary">Iniciar Sesión</h3>
      <p class="text-muted small">Accedé a tu cuenta para continuar</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="login()">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-envelope"></i>
          </span>
          <input
            type="email"
            id="email"
            class="form-control"
            formControlName="email"
            [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched"
            placeholder="ejemplo@correo.com"
          />
          <div class="invalid-feedback">Email inválido</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="password" class="form-label">Contraseña</label>
        <div class="input-group">
          <span class="input-group-text">
            <i class="fa-solid fa-lock"></i>
          </span>
          <input
            type="password"
            id="password"
            class="form-control"
            formControlName="password"
            [class.is-invalid]="form.get('password')?.invalid && form.get('password')?.touched"
            placeholder="********"
          />
          <div class="invalid-feedback">Contraseña requerida</div>
        </div>
      </div>

      <div *ngIf="error" class="alert alert-danger small py-2">{{ error }}</div>

      <button
        type="submit"
        class="btn btn-primary w-100 mb-3"
        [disabled]="form.invalid || loading"
      >
        {{ loading ? 'Ingresando...' : 'Ingresar' }}
      </button>

      <div class="d-flex justify-content-between small">
        <a style="cursor: pointer;" (click)="recuperarPassword()">¿Olvidaste tu contraseña?</a>
        <a style="cursor: pointer;" (click)="crearCuenta()">Crear cuenta</a>
      </div>
    </form>
  </div>
</div>
